import vue from 'vue'

import dialogComponent from './index.vue'

const DialogConstructor = vue.extend(dialogComponent)

// 定义弹出组件的函数 接收2个参数, 要显示的文本 和 显示时间
function dialog(data = {}) {
  // 实例化一个 pop.vue
  const instance = new DialogConstructor({
    el: document.createElement('div')
  })
  instance.dialogDisplay = true
  instance.dialogData = data
  // 把 实例化的 pop.vue 添加到 body 里
  document.body.appendChild(instance.$el)
}

// 注册为全局组件的函数
function registryDialog() {
  vue.prototype.$dialog = dialog
}

export default registryDialog



// WEBPACK FOOTER //
// ./src/base/dialog/index.js